import { faDownload } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { MenuItem } from '../../common';

type DownloadPropsType = {
  onClick: () => void;
  disabled?: boolean;
};

export const Download: React.FC<DownloadPropsType> = ({
  onClick,
  disabled,
}) => {
  const { t } = useTranslation();
  return (
    <MenuItem
      leftSection={<FontAwesomeIcon icon={faDownload} />}
      onClick={onClick}
      disabled={disabled}
    >
      {t('FILE_TREE_CONTEXT_MENU.DOWNLOAD')}
    </MenuItem>
  );
};
